module.exports = __webpack_public_path__ + "static/media/key-cluster-icon.dc27402b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/route-finder/key-cluster-icon.svg
// module id = 842
// module chunks = 0